<template>
  <div class="job-multi-file-upload-view d-flex flex-column">
    <div class="breadcrumb-header pa-4 flex-grow-0">
      <v-btn icon @click="closeScreen" class="mr-2">
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>
      <span class="text-h6">{{ jobData.job_title || 'Job' }}</span>
      <v-icon class="mx-2">mdi-chevron-right</v-icon>
      <span class="text-h6 grey--text">{{ $t('multi_file_upload') }}</span>
    </div>

    <JobMultiFileUploadManagement
      class="flex-grow-1"
      :job-id="jobId"
      :job-data="jobData"
      :customer-id="customerId"
      :content-app-id="$route.params.contentAppId"
    />
  </div>
</template>

<script>
import JobMultiFileUploadManagement from '@/components/job/JobMultiFileUploadManagement.vue'
import JobAPI from '@/services/api/job/job'

export default {
  name: 'JobMultiFileUpload',

  components: {
    JobMultiFileUploadManagement
  },

  props: {
    jobId: {
      type: [String, Number],
      default: null
    },
    customerId: {
      type: [String, Number],
      default: null
    }
  },

  data() {
    return {
      jobData: {}
    }
  },

  mounted() {
    this.loadJobData()
  },

  methods: {
    async loadJobData() {
      const effectiveJobId = this.jobId || this.$route.params.jobId

      if (!effectiveJobId) return

      try {
        const response = await JobAPI.getJob(effectiveJobId)
        this.jobData = response.data || {}
      } catch (error) {
        console.error('Error loading job data:', error)
      }
    },

    closeScreen() {
      this.$router.back()
    }
  }
}
</script>

<style scoped>
.job-multi-file-upload-view {
  height: calc(100vh - 64px);
  background-color: #f5f5f5;
  overflow: hidden;
}

/* `flex-grow-1` alone doesn't guarantee a "definite" height for the
   management component in every browser - give it an explicit min-height:0
   (flex items default to min-height: auto, which lets them grow past the
   parent's fixed height once their content loads) and let it resolve its
   own height against this flex row via flex-basis 0 (implied by flex-grow). */
.job-multi-file-upload-view > .job-multi-file-upload-management {
  min-height: 0;
  flex-basis: 0;
}
</style>
